export default __webpack_public_path__ + "static/narondziewlewo-0dd33739728365b723d4cd9e3595df43.png";